import { css } from 'lit';

export const likesStyles = css` 
  :host {
   display: inline-block;
  }
    .likes-container {
        display: flex;
        align-items: center;
        gap: var(--sbkCoreSpacing3xs);
    }
`;